import { render, staticRenderFns } from "./WDGFooter.vue?vue&type=template&id=69c5555d&"
import script from "./WDGFooter.vue?vue&type=script&lang=js&"
export * from "./WDGFooter.vue?vue&type=script&lang=js&"
import style0 from "./WDGFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../prospect-setup/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports